import { ReactElement, useState } from "react";
import { CreatePublicSourcingEventModal } from "./CreatePublicSourcingEventModal";

export const useCreatePublicSourcingEventModal = (): {
  show: () => void;
  modal: ReactElement;
} => {
  const [isOpen, setIsOpen] = useState(false);
  return {
    show: () => setIsOpen(true),
    modal: <CreatePublicSourcingEventModal isOpen={isOpen} onClose={() => setIsOpen(false)} />,
  };
};
